export interface GovAccordionItemChangeEvent {
	open: boolean;
	element: HTMLGovAccordionItemElement
}
